import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

export const FaqSection = () => {
  const { t, lang } = useLang();
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/public/faqs").then((r) => setFaqs(r.data)).catch(() => setFaqs([])); }, []);
  return (
    <section className="container-z grid gap-10 py-20 lg:grid-cols-[1fr_1.6fr]" aria-labelledby="faq-title" data-testid="faq-section">
      <div>
        <p className="eyebrow">{t("faq.eyebrow")}</p>
        <h2 id="faq-title" className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">{t("faq.title")}</h2>
      </div>
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((f) => (
          <AccordionItem key={f.faq_id} value={f.faq_id} className="border-navy/10">
            <AccordionTrigger className="text-left text-base font-semibold text-navy hover:no-underline" data-testid={`faq-trigger-${f.faq_id}`}>
              {lang === "hi" ? f.question_hi : f.question_en}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-navy/70">{lang === "hi" ? f.answer_hi : f.answer_en}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export const CtaBand = () => {
  const { t } = useLang();
  const { user } = useAuth();
  return (
    <section className="container-z pb-20" data-testid="cta-section">
      <div className="flex flex-col items-start justify-between gap-6 rounded-3xl bg-brand p-8 text-white sm:p-12 md:flex-row md:items-center">
        <div>
          <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">{t("cta.title")}</h2>
          <p className="mt-2 text-white/85">{t("cta.sub")}</p>
        </div>
        <Link to={user ? "/solve" : "/signup"} className="inline-flex items-center rounded-full bg-white px-6 py-3 text-sm font-semibold text-navy hover:bg-cyan" style={{ transition: "background-color .2s" }} data-testid="cta-primary-button">
          {user ? t("nav.solve") : t("cta.btn")}
        </Link>
      </div>
    </section>
  );
};
